module.exports = __webpack_public_path__ + "static/media/xhama.4290eb4a.jpg";